import { qeddyArtwork } from "./qeddyArtwork";

export type QeddyIconProps = {
  size?: number;
  disabled?: boolean;
};

export function QeddyIcon({ size = 20, disabled = false }: QeddyIconProps) {
  return (
    <img
      aria-hidden="true"
      alt=""
      src={qeddyArtwork}
      width={size}
      height={size}
      draggable={false}
      style={{
        width: size,
        height: size,
        display: "block",
        objectFit: "contain",
        opacity: disabled ? 0.42 : 1
      }}
    />
  );
}
